<template>
    <div class="container-fluid px-0">
        <!-- Barra Superiore / Header -->
        <div class="card shadow mb-3 border-left-primary">
            <div class="card-body py-2">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <h4 class="mb-0 text-primary font-weight-bold">
                            <i class="fad fa-file-invoice-dollar mr-2 text-success"></i> Pagamento Ruoli Terreni
                        </h4>
                        <small class="text-muted">Tracciamento e gestione incassi dei bollettini / avvisi di pagamento emessi</small>
                    </div>
                    <div class="col-md-6 text-right">
                        <button type="button" class="btn btn-outline-secondary btn-sm mr-2" v-on:click="tornaDashboard()">
                            <i class="fas fa-arrow-left mr-1"></i> Dashboard
                        </button>
                        <button type="button" class="btn btn-primary btn-sm mr-2" v-on:click="apriModaleGenerazione()">
                            <i class="fas fa-sync-alt mr-1"></i> Genera / Emetti Ruolo
                        </button>
                        <button type="button" class="btn btn-info btn-sm" v-if="selezionati.length > 0" v-on:click="segnaSelezionatiInviati()">
                            <i class="fas fa-paper-plane mr-1"></i> Segna {{ selezionati.length }} come Inviati
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- KPI Cards Summary -->
        <div class="row mb-3">
            <div class="col-xl-3 col-md-6 mb-2">
                <div class="card border-left-primary shadow h-100 py-2">
                    <div class="card-body py-2">
                        <div class="row no-gutters align-items-center">
                            <div class="col mr-2">
                                <div class="text-xs font-weight-bold text-primary text-uppercase mb-1">Bollettini Emessi ({{ annoSelezionato }})</div>
                                <div class="h5 mb-0 font-weight-bold text-gray-800">€ {{ formatValuta(kpi.totaleEmesso) }}</div>
                                <small class="text-muted">{{ kpi.conteggioEmessi }} bollettini totali</small>
                            </div>
                            <div class="col-auto">
                                <i class="fad fa-file-invoice fa-2x text-gray-300"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-xl-3 col-md-6 mb-2">
                <div class="card border-left-info shadow h-100 py-2">
                    <div class="card-body py-2">
                        <div class="row no-gutters align-items-center">
                            <div class="col mr-2">
                                <div class="text-xs font-weight-bold text-info text-uppercase mb-1">Inviati</div>
                                <div class="h5 mb-0 font-weight-bold text-gray-800">{{ kpi.conteggioInviati }} bollettini</div>
                                <small class="text-muted">€ {{ formatValuta(kpi.totaleInviati) }} notificati</small>
                            </div>
                            <div class="col-auto">
                                <i class="fad fa-paper-plane fa-2x text-gray-300"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-xl-3 col-md-6 mb-2">
                <div class="card border-left-success shadow h-100 py-2">
                    <div class="card-body py-2">
                        <div class="row no-gutters align-items-center">
                            <div class="col mr-2">
                                <div class="text-xs font-weight-bold text-success text-uppercase mb-1">Incassati / Pagati</div>
                                <div class="h5 mb-0 font-weight-bold text-gray-800">€ {{ formatValuta(kpi.totalePagato) }}</div>
                                <small class="text-success font-weight-bold">{{ kpi.conteggioPagati }} bollettini saldati</small>
                            </div>
                            <div class="col-auto">
                                <i class="fad fa-check-circle fa-2x text-gray-300"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-xl-3 col-md-6 mb-2">
                <div class="card border-left-warning shadow h-100 py-2">
                    <div class="card-body py-2">
                        <div class="row no-gutters align-items-center">
                            <div class="col mr-2">
                                <div class="text-xs font-weight-bold text-warning text-uppercase mb-1">Residuo da Incassare</div>
                                <div class="h5 mb-0 font-weight-bold text-danger">€ {{ formatValuta(kpi.totaleDaIncassare) }}</div>
                                <small class="text-muted">{{ kpi.conteggioDaIncassare }} da saldare</small>
                            </div>
                            <div class="col-auto">
                                <i class="fad fa-hourglass-half fa-2x text-gray-300"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Filtri di Ricerca -->
        <div class="card shadow mb-3">
            <div class="card-body py-2 bg-light">
                <div class="row align-items-center">
                    <div class="col-md-2 col-sm-6 mb-2 mb-md-0">
                        <label class="small font-weight-bold mb-1">Anno Ruolo</label>
                        <select class="form-control form-control-sm" v-model="annoSelezionato" v-on:change="caricaBollettini()">
                            <option v-for="a in arrayAnni" :key="a" :value="a">{{ a }}</option>
                        </select>
                    </div>
                    <div class="col-md-2 col-sm-6 mb-2 mb-md-0">
                        <label class="small font-weight-bold mb-1">Stato Pagamento</label>
                        <select class="form-control form-control-sm" v-model="filtroStato" v-on:change="applicaFiltri()">
                            <option value="">- Tutti gli stati -</option>
                            <option value="Generato">Generato</option>
                            <option value="Inviato">Inviato</option>
                            <option value="Pagato">Pagato</option>
                        </select>
                    </div>
                    <div class="col-md-5 col-sm-12 mb-2 mb-md-0">
                        <label class="small font-weight-bold mb-1">Ricerca Intestatario / Bollettino / Terreno</label>
                        <div class="input-group input-group-sm">
                            <input type="text" class="form-control" placeholder="Cerca per Cognome, Nome, C.F., N. Bollettino, Località..." v-model="testoRicerca" v-on:keyup.enter="caricaBollettini()">
                            <div class="input-group-append">
                                <button class="btn btn-primary" type="button" v-on:click="caricaBollettini()">
                                    <i class="fas fa-search"></i>
                                </button>
                                <button class="btn btn-outline-secondary" type="button" v-if="testoRicerca" v-on:click="resetRicerca()">
                                    <i class="fas fa-times"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 text-right mt-3 mt-md-0">
                        <button type="button" class="btn btn-outline-dark btn-sm mr-1" v-on:click="stampaRuoloCompleto()">
                            <i class="fas fa-print mr-1"></i> Stampa Tutti PDF
                        </button>
                        <button type="button" class="btn btn-outline-secondary btn-sm" v-on:click="caricaBollettini()">
                            <i class="fas fa-redo"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Tabella Bollettini -->
        <div class="card shadow mb-4">
            <div class="card-body p-0">
                <div class="table-responsive" style="max-height: 650px; overflow-y: auto;">
                    <table class="table table-hover table-striped mb-0 table-sm" style="font-size: 0.88rem;">
                        <thead class="thead-dark sticky-top" style="z-index: 10;">
                            <tr>
                                <th style="width: 35px;" class="text-center">
                                    <input type="checkbox" v-model="selezionaTutti" v-on:change="toggleSelezionaTutti()">
                                </th>
                                <th style="width: 135px;">N. Bollettino</th>
                                <th style="width: 220px;">Intestatario</th>
                                <th>Terreni Associati (Snapshot)</th>
                                <th style="width: 110px;" class="text-right">Importo (€)</th>
                                <th style="width: 105px;" class="text-center">Stato</th>
                                <th style="width: 130px;">Date Tracciate</th>
                                <th style="width: 160px;" class="text-center">Azioni</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="caricamento">
                                <td colspan="8" class="text-center py-4 text-muted">
                                    <i class="fas fa-spinner fa-spin fa-2x"></i><br>
                                    Caricamento bollettini in corso...
                                </td>
                            </tr>
                            <tr v-else-if="bollettiniFiltrati.length == 0">
                                <td colspan="8" class="text-center py-4 text-muted">
                                    <i class="fal fa-inbox fa-3x mb-2"></i><br>
                                    Nessun bollettino trovato per i filtri selezionati per l'anno {{ annoSelezionato }}.<br>
                                    <button class="btn btn-primary btn-sm mt-2" v-on:click="apriModaleGenerazione()">
                                        <i class="fas fa-plus mr-1"></i> Genera Bollettini per il {{ annoSelezionato }}
                                    </button>
                                </td>
                            </tr>
                            <tr v-for="b in bollettiniFiltrati" :key="b.ID_BOLLETTINO" :class="{'table-success': b.STATO == 'Pagato'}">
                                <td class="text-center align-middle">
                                    <input type="checkbox" :value="b.ID_BOLLETTINO" v-model="selezionati" :disabled="b.STATO == 'Pagato'">
                                </td>
                                <td class="align-middle font-weight-bold text-primary">
                                    {{ b.CODICE_BOLLETTINO }}
                                    <br><small class="text-muted">Anno {{ b.ANNO }}</small>
                                </td>
                                <td class="align-middle">
                                    <strong>{{ b.INTESTATARIO_COGNOME }} {{ b.INTESTATARIO_NOME }}</strong>
                                    <br>
                                    <small class="text-muted">C.F. {{ b.INTESTATARIO_CF }}</small>
                                    <span v-if="b.INTESTATARIO_COMUNE" class="small text-secondary d-block">
                                        {{ b.INTESTATARIO_COMUNE }} <span v-if="b.INTESTATARIO_PROV">({{ b.INTESTATARIO_PROV }})</span>
                                    </span>
                                </td>
                                <td class="align-middle">
                                    <span class="badge badge-light border mr-1">
                                        <i class="fas fa-layer-group text-muted"></i> {{ b.NUM_TERRENI }} terreni
                                    </span>
                                    <small class="text-dark d-inline-block" style="max-width: 320px; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; vertical-align: bottom;" :title="b.RIEPILOGO_TERRENI">
                                        {{ b.RIEPILOGO_TERRENI || 'Nessun dettaglio' }}
                                    </small>
                                </td>
                                <td class="align-middle text-right font-weight-bold" style="font-size: 0.95rem;">
                                    € {{ formatValuta(b.TOTALE_DOVUTO) }}
                                    <div class="small text-muted" v-if="parseFloat(b.SPESE_NOTIFICA) > 0">
                                        + € {{ formatValuta(b.SPESE_NOTIFICA) }} notifica
                                    </div>
                                </td>
                                <td class="align-middle text-center">
                                    <span v-if="b.STATO == 'Generato'" class="badge badge-warning text-dark px-2 py-1">
                                        <i class="fas fa-clock mr-1"></i> Generato
                                    </span>
                                    <span v-else-if="b.STATO == 'Inviato'" class="badge badge-primary px-2 py-1">
                                        <i class="fas fa-paper-plane mr-1"></i> Inviato
                                    </span>
                                    <span v-else-if="b.STATO == 'Pagato'" class="badge badge-success px-2 py-1">
                                        <i class="fas fa-check-circle mr-1"></i> Pagato
                                    </span>
                                </td>
                                <td class="align-middle small">
                                    <div><i class="fal fa-file-alt text-muted" title="Data Generazione"></i> {{ b.DATA_GEN_FMT }}</div>
                                    <div v-if="b.DATA_INVIO_FMT" class="text-primary"><i class="fal fa-paper-plane" title="Data Invio"></i> {{ b.DATA_INVIO_FMT }}</div>
                                    <div v-if="b.DATA_PAG_FMT" class="text-success font-weight-bold">
                                        <i class="fal fa-receipt" title="Data Pagamento"></i> {{ b.DATA_PAG_FMT }}
                                        <span v-if="b.MODALITA_PAGAMENTO" class="badge badge-light border">({{ b.MODALITA_PAGAMENTO }})</span>
                                    </div>
                                </td>
                                <td class="align-middle text-center" style="white-space: nowrap;">
                                    <button type="button" class="btn btn-info btn-sm btn-azione" title="Scheda Snapshot Dettaglio" v-on:click="apriDettaglio(b)">
                                        <i class="fas fa-eye"></i>
                                    </button>
                                    <button type="button" class="btn btn-danger btn-sm btn-azione" title="Stampa PDF Bollettino Singolo" v-on:click="stampaBollettinoSingolo(b)">
                                        <i class="fas fa-file-pdf"></i>
                                    </button>
                                    <button v-if="b.STATO != 'Pagato'" type="button" class="btn btn-success btn-sm btn-azione" title="Registra Pagamento" v-on:click="apriModalePagamento(b)">
                                        <i class="fas fa-dollar-sign"></i>
                                    </button>
                                    <button v-if="b.STATO == 'Generato'" type="button" class="btn btn-primary btn-sm btn-azione" title="Segna come Inviato" v-on:click="segnaInviatoSingolo(b)">
                                        <i class="fas fa-paper-plane"></i>
                                    </button>
                                    <button v-if="b.STATO == 'Pagato'" type="button" class="btn btn-warning btn-sm btn-azione" title="Annulla Pagamento / Riporta a Generato" v-on:click="riportaGenerato(b)">
                                        <i class="fas fa-undo"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="card-footer py-2 bg-light text-muted small d-flex justify-content-between align-items-center">
                <span>Visualizzati <strong>{{ bollettiniFiltrati.length }}</strong> di <strong>{{ arrayBollettini.length }}</strong> bollettini</span>
                <span>Anno selezionato: <strong>{{ annoSelezionato }}</strong></span>
            </div>
        </div>

        <!-- MODALE REGISTRAZIONE PAGAMENTO -->
        <div class="modal fade" id="popUpPagamento" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-md" role="document">
                <div class="modal-content" v-if="bollettinoInAzione">
                    <div class="modal-header bg-success text-white">
                        <h5 class="modal-title font-weight-bold">
                            <i class="fas fa-receipt mr-2"></i> Registra Pagamento Bollettino
                        </h5>
                        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-light border">
                            <strong>Bollettino:</strong> {{ bollettinoInAzione.CODICE_BOLLETTINO }} (Anno {{ bollettinoInAzione.ANNO }})<br>
                            <strong>Intestatario:</strong> {{ bollettinoInAzione.INTESTATARIO_COGNOME }} {{ bollettinoInAzione.INTESTATARIO_NOME }} (C.F. {{ bollettinoInAzione.INTESTATARIO_CF }})<br>
                            <strong>Importo Totale Dovuto:</strong> <span class="h5 font-weight-bold text-success">€ {{ formatValuta(bollettinoInAzione.TOTALE_DOVUTO) }}</span>
                        </div>

                        <div class="form-group">
                            <label><strong>Data di Pagamento</strong></label>
                            <input type="date" class="form-control" v-model="formPagamento.dataPagamento">
                        </div>

                        <div class="form-group">
                            <label><strong>Modalità di Pagamento</strong></label>
                            <select class="form-control" v-model="formPagamento.modalita">
                                <option value="Bonifico">Bonifico Bancario</option>
                                <option value="PagoPA">PagoPA</option>
                                <option value="Contanti">Contanti / Sportello Cassa</option>
                                <option value="POS">POS / Carta di Credito</option>
                                <option value="Altro">Altro</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label><strong>Note Pagamento / Riferimento Ricevuta</strong></label>
                            <input type="text" class="form-control" placeholder="es. TRN bonifico o N. quietanza..." v-model="formPagamento.note">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Annulla</button>
                        <button type="button" class="btn btn-success" v-on:click="salvaPagamento()">
                            <i class="fas fa-check mr-1"></i> Conferma Incasso
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- MODALE DETTAGLIO SNAPSHOT BOLLETTINO -->
        <div class="modal fade" id="popUpDettaglio" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg" style="min-width: 850px;" role="document">
                <div class="modal-content" v-if="dettaglioBollettino">
                    <div class="modal-header" style="background-color: #1a365d; color: #fff;">
                        <h5 class="modal-title text-white">
                            <i class="fas fa-archive mr-2"></i> Scheda Snapshot Bollettino {{ dettaglioBollettino.CODICE_BOLLETTINO }}
                        </h5>
                        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <!-- Intestazione con info anagrafiche congelate -->
                        <div class="row mb-3">
                            <div class="col-md-6">
                                <div class="card bg-light border h-100">
                                    <div class="card-body py-2">
                                        <span class="text-muted small font-weight-bold">INTESTATARIO CONGELATO ALLO SNAPSHOT</span>
                                        <div class="h5 font-weight-bold text-dark mb-1">
                                            {{ dettaglioBollettino.INTESTATARIO_COGNOME }} {{ dettaglioBollettino.INTESTATARIO_NOME }}
                                        </div>
                                        <div class="small"><strong>Codice Fiscale:</strong> {{ dettaglioBollettino.INTESTATARIO_CF }}</div>
                                        <div class="small"><strong>Indirizzo:</strong> {{ dettaglioBollettino.INTESTATARIO_INDIRIZZO || '-' }}</div>
                                        <div class="small"><strong>Comune:</strong> {{ dettaglioBollettino.INTESTATARIO_CAP }} {{ dettaglioBollettino.INTESTATARIO_COMUNE }} ({{ dettaglioBollettino.INTESTATARIO_PROV }})</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="card bg-light border h-100">
                                    <div class="card-body py-2">
                                        <span class="text-muted small font-weight-bold">STATO E TRACCIAMENTO</span>
                                        <div>
                                            <strong>Stato Attuale: </strong>
                                            <span v-if="dettaglioBollettino.STATO == 'Generato'" class="badge badge-warning">Generato</span>
                                            <span v-else-if="dettaglioBollettino.STATO == 'Inviato'" class="badge badge-primary">Inviato</span>
                                            <span v-else-if="dettaglioBollettino.STATO == 'Pagato'" class="badge badge-success">Pagato</span>
                                        </div>
                                        <div class="small mt-1"><strong>Data Generazione:</strong> {{ dettaglioBollettino.DATA_GEN_FMT }}</div>
                                        <div class="small"><strong>Data Invio:</strong> {{ dettaglioBollettino.DATA_INVIO_FMT || 'Non ancora inviato' }}</div>
                                        <div class="small"><strong>Data Pagamento:</strong> {{ dettaglioBollettino.DATA_PAG_FMT || 'In attesa di pagamento' }}</div>
                                        <div class="small" v-if="dettaglioBollettino.MODALITA_PAGAMENTO"><strong>Modalità:</strong> {{ dettaglioBollettino.MODALITA_PAGAMENTO }}</div>
                                        <div class="small" v-if="dettaglioBollettino.NOTE_PAGAMENTO"><strong>Note Pagamento:</strong> {{ dettaglioBollettino.NOTE_PAGAMENTO }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Terreni congelati allo snapshot -->
                        <h6 class="font-weight-bold text-primary mb-2">
                            <i class="fas fa-tractor mr-1"></i> Terreni Inclusi nel Bollettino (Snapshot immutabile)
                        </h6>
                        <table class="table table-bordered table-sm mb-3" style="font-size: 0.85rem;">
                            <thead class="thead-light">
                                <tr>
                                    <th>Appezzamento / Località</th>
                                    <th class="text-center" style="width: 70px;">Foglio</th>
                                    <th class="text-center" style="width: 80px;">Particella</th>
                                    <th class="text-center" style="width: 90px;">Superficie</th>
                                    <th class="text-right" style="width: 110px;">Canone (€)</th>
                                    <th class="text-right" style="width: 110px;">Addizionale (€)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="v in dettaglioBollettino.VOCI" :key="v.ID_VOCE">
                                    <td>
                                        <strong>{{ v.LOCALITA }}</strong>
                                        <span v-if="v.ID_APPEZZAMENTO" class="text-muted small"> (App. {{ v.ID_APPEZZAMENTO }})</span>
                                        <div v-if="v.TIPO_TERRENO_DESC" class="small text-secondary">{{ v.TIPO_TERRENO_DESC }}</div>
                                    </td>
                                    <td class="text-center">{{ v.FOGLIO }}</td>
                                    <td class="text-center">{{ v.PARTICELLA }}</td>
                                    <td class="text-center">{{ v.SUPERFICIE }}</td>
                                    <td class="text-right font-weight-bold">€ {{ formatValuta(v.CANONE_TOT) }}</td>
                                    <td class="text-right text-purple">€ {{ formatValuta(v.ADDIZIONALE) }}</td>
                                </tr>
                            </tbody>
                        </table>

                        <!-- Rate congelate -->
                        <h6 class="font-weight-bold text-primary mb-2">
                            <i class="fas fa-calendar-alt mr-1"></i> Rateizzazione Programmata
                        </h6>
                        <table class="table table-bordered table-sm mb-3" style="font-size: 0.85rem;">
                            <thead class="thead-light">
                                <tr>
                                    <th>Rata</th>
                                    <th>Scadenza</th>
                                    <th class="text-right">Importo Rata</th>
                                    <th class="text-center">Stato</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="r in dettaglioBollettino.RATE" :key="r.ID_RATA">
                                    <td><strong>{{ r.DESCRIZIONE }}</strong></td>
                                    <td>{{ r.DATA_SCADENZA }}</td>
                                    <td class="text-right font-weight-bold">€ {{ formatValuta(r.IMPORTO) }}</td>
                                    <td class="text-center">
                                        <span class="badge" :class="r.STATO == 'Pagata' ? 'badge-success' : 'badge-secondary'">
                                            {{ r.STATO }}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <!-- Riepilogo totali -->
                        <div class="row justify-content-end">
                            <div class="col-md-5">
                                <table class="table table-sm border" style="font-size: 0.88rem;">
                                    <tbody>
                                        <tr>
                                            <td>Totale Canoni:</td>
                                            <td class="text-right font-weight-bold">€ {{ formatValuta(dettaglioBollettino.TOTALE_CANONI) }}</td>
                                        </tr>
                                        <tr v-if="parseFloat(dettaglioBollettino.TOTALE_ADDIZIONALE) > 0">
                                            <td>Quote Addizionali:</td>
                                            <td class="text-right font-weight-bold text-purple">€ {{ formatValuta(dettaglioBollettino.TOTALE_ADDIZIONALE) }}</td>
                                        </tr>
                                        <tr v-if="parseFloat(dettaglioBollettino.SPESE_NOTIFICA) > 0">
                                            <td>Spese Notifica:</td>
                                            <td class="text-right font-weight-bold">€ {{ formatValuta(dettaglioBollettino.SPESE_NOTIFICA) }}</td>
                                        </tr>
                                        <tr class="table-primary font-weight-bold" style="font-size: 1rem;">
                                            <td>TOTALE DOVUTO:</td>
                                            <td class="text-right text-primary">€ {{ formatValuta(dettaglioBollettino.TOTALE_DOVUTO) }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Chiudi</button>
                        <button type="button" class="btn btn-danger" v-on:click="stampaBollettinoSingolo(dettaglioBollettino)">
                            <i class="fas fa-file-pdf mr-1"></i> Stampa Bollettino PDF
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- MODALE GENERAZIONE RUOLO / BOLLETTINI -->
        <div class="modal fade" id="popUpGeneraRuolo" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-md" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-primary text-white">
                        <h5 class="modal-title font-weight-bold">
                            <i class="fas fa-sync-alt mr-2"></i> Genera / Sincronizza Ruolo Terreni
                        </h5>
                        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info small">
                            Questa operazione estrae tutte le assegnazioni attive dei terreni per l'anno specificato e genera i bollettini con lo snapshot congelato su database.
                            <br><strong>Nota:</strong> I bollettini già contrassegnati come <em>Pagati</em> non verranno sovrascritti.
                        </div>

                        <div class="form-group">
                            <label><strong>Anno Ruolo</strong></label>
                            <input type="number" class="form-control" v-model="formGenera.anno">
                        </div>

                        <div class="form-group">
                            <label><strong>Numero Rate</strong></label>
                            <select class="form-control" v-model="formGenera.numeroRate">
                                <option value="2">2 Rate (Luglio / Agosto)</option>
                                <option value="3">3 Rate (Luglio / Settembre / Novembre)</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label><strong>Spese di Notifica (€)</strong></label>
                            <input type="number" step="0.01" class="form-control" placeholder="0.00" v-model="formGenera.speseNotifica">
                        </div>

                        <div class="form-group">
                            <label><strong>Filtro Iniziale Cognome</strong></label>
                            <select class="form-control" v-model="formGenera.lettera">
                                <option value="+">- Tutti gli assegnatari -</option>
                                <option v-for="l in lettereAlfabeto" :key="l" :value="l">{{ l }}</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label><strong>Presidente Firmatario</strong></label>
                            <input type="text" class="form-control" v-model="formGenera.presidente">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Annulla</button>
                        <button type="button" class="btn btn-primary" v-on:click="eseguiGenerazioneRuolo()">
                            <i class="fas fa-cogs mr-1"></i> Avvia Generazione Bollettini
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PagamentiRuoli",
    data: function () {
        return {
            caricamento: false,
            arrayAnni: [],
            annoSelezionato: new Date().getFullYear(),
            filtroStato: "",
            testoRicerca: "",
            arrayBollettini: [],
            selezionati: [],
            selezionaTutti: false,
            bollettinoInAzione: null,
            dettaglioBollettino: null,
            lettereAlfabeto: ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"],
            formPagamento: {
                dataPagamento: new Date().toISOString().substring(0, 10),
                modalita: "Bonifico",
                note: ""
            },
            formGenera: {
                anno: new Date().getFullYear(),
                numeroRate: 2,
                speseNotifica: 0.00,
                lettera: "+",
                presidente: "Il Presidente"
            }
        };
    },
    computed: {
        bollettiniFiltrati: function () {
            var lista = this.arrayBollettini;
            if (this.filtroStato) {
                lista = lista.filter(b => b.STATO === this.filtroStato);
            }
            if (this.testoRicerca && this.testoRicerca.trim() !== "") {
                var q = this.testoRicerca.toLowerCase().trim();
                lista = lista.filter(b => {
                    return (b.INTESTATARIO_COGNOME && b.INTESTATARIO_COGNOME.toLowerCase().includes(q)) ||
                           (b.INTESTATARIO_NOME && b.INTESTATARIO_NOME.toLowerCase().includes(q)) ||
                           (b.INTESTATARIO_CF && b.INTESTATARIO_CF.toLowerCase().includes(q)) ||
                           (b.CODICE_BOLLETTINO && b.CODICE_BOLLETTINO.toLowerCase().includes(q)) ||
                           (b.RIEPILOGO_TERRENI && b.RIEPILOGO_TERRENI.toLowerCase().includes(q));
                });
            }
            return lista;
        },
        kpi: function () {
            var totaleEmesso = 0;
            var conteggioEmessi = this.arrayBollettini.length;
            var totaleInviati = 0;
            var conteggioInviati = 0;
            var totalePagato = 0;
            var conteggioPagati = 0;
            var totaleDaIncassare = 0;
            var conteggioDaIncassare = 0;

            for (var i = 0; i < this.arrayBollettini.length; i++) {
                var b = this.arrayBollettini[i];
                var importo = parseFloat(b.TOTALE_DOVUTO) || 0;
                totaleEmesso += importo;

                if (b.STATO === "Inviato") {
                    totaleInviati += importo;
                    conteggioInviati++;
                } else if (b.STATO === "Pagato") {
                    totalePagato += importo;
                    conteggioPagati++;
                }

                if (b.STATO !== "Pagato") {
                    totaleDaIncassare += importo;
                    conteggioDaIncassare++;
                }
            }

            return {
                totaleEmesso: totaleEmesso,
                conteggioEmessi: conteggioEmessi,
                totaleInviati: totaleInviati,
                conteggioInviati: conteggioInviati,
                totalePagato: totalePagato,
                conteggioPagati: conteggioPagati,
                totaleDaIncassare: totaleDaIncassare,
                conteggioDaIncassare: conteggioDaIncassare
            };
        }
    },
    methods: {
        tornaDashboard: function () {
            global.router.push('/dashboard');
        },
        formatValuta: function (num) {
            if (num === null || num === undefined || isNaN(num)) return "0,00";
            return parseFloat(num).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
        caricaAnni: function () {
            global.utils.get('/emmet/bollettini/anni', {}, (response) => {
                if (response && response.data) {
                    this.arrayAnni = response.data;
                    if (this.arrayAnni.length > 0 && !this.arrayAnni.includes(this.annoSelezionato)) {
                        this.annoSelezionato = this.arrayAnni[0];
                    }
                }
                this.caricaBollettini();
            });
        },
        caricaBollettini: function () {
            this.caricamento = true;
            this.selezionati = [];
            this.selezionaTutti = false;
            global.utils.get('/emmet/bollettini', {
                ANNO: this.annoSelezionato,
                SEARCH: this.testoRicerca
            }, (response) => {
                this.caricamento = false;
                if (response && response.data) {
                    this.arrayBollettini = response.data;
                } else {
                    this.arrayBollettini = [];
                }
            });
        },
        applicaFiltri: function () {
            this.selezionati = [];
            this.selezionaTutti = false;
        },
        resetRicerca: function () {
            this.testoRicerca = "";
            this.caricaBollettini();
        },
        toggleSelezionaTutti: function () {
            if (this.selezionaTutti) {
                this.selezionati = this.bollettiniFiltrati
                    .filter(b => b.STATO !== 'Pagato')
                    .map(b => b.ID_BOLLETTINO);
            } else {
                this.selezionati = [];
            }
        },
        apriModaleGenerazione: function () {
            this.formGenera.anno = this.annoSelezionato;
            global.utils.openModal('popUpGeneraRuolo');
        },
        eseguiGenerazioneRuolo: function () {
            global.utils.post('/emmet/bollettini/genera', {
                ANNO: this.formGenera.anno,
                NUMERO_RATE: this.formGenera.numeroRate,
                SPESE_NOTIFICA: this.formGenera.speseNotifica,
                LETTERA: this.formGenera.lettera,
                PRESIDENTE: this.formGenera.presidente
            }, (response) => {
                global.utils.closeModal('popUpGeneraRuolo');
                if (response && response.esito == 0) {
                    global.utils.notifySuccess("Ruolo generato con successo (" + response.generati + " nuovi, " + response.aggiornati + " aggiornati, " + response.saltati + " protetti già pagati).");
                    this.annoSelezionato = this.formGenera.anno;
                    this.caricaAnni();
                } else {
                    global.utils.notifyError(response.messaggio || "Errore nella generazione del ruolo.");
                }
            });
        },
        apriDettaglio: function (bollettino) {
            global.utils.get('/emmet/bollettini/dettaglio', { ID_BOLLETTINO: bollettino.ID_BOLLETTINO }, (response) => {
                if (response && response.data) {
                    this.dettaglioBollettino = response.data;
                    global.utils.openModal('popUpDettaglio');
                } else {
                    global.utils.notifyError("Impossibile caricare il dettaglio del bollettino.");
                }
            });
        },
        stampaBollettinoSingolo: function (bollettino) {
            var url = global.utils.BASE_API + "core/report?ID_REPORT=1004&ID_BOLLETTINO=" + bollettino.ID_BOLLETTINO + "&SESSION_TOKEN=" + global.utils.SESSION_TOKEN;
            window.open(url);
        },
        stampaRuoloCompleto: function () {
            var url = global.utils.BASE_API + "core/report?ID_REPORT=1004&ANNO=" + this.annoSelezionato + "&SESSION_TOKEN=" + global.utils.SESSION_TOKEN;
            window.open(url);
        },
        segnaInviatoSingolo: function (bollettino) {
            global.utils.post('/emmet/bollettino/stato', {
                ID_BOLLETTINO: bollettino.ID_BOLLETTINO,
                STATO: 'Inviato'
            }, (response) => {
                if (response && response.esito == 0) {
                    global.utils.notifySuccess("Bollettino " + bollettino.CODICE_BOLLETTINO + " segnato come Inviato.");
                    this.caricaBollettini();
                }
            });
        },
        segnaSelezionatiInviati: function () {
            if (this.selezionati.length === 0) return;
            global.utils.post('/emmet/bollettini/invia_multipli', {
                IDS: this.selezionati
            }, (response) => {
                if (response && response.esito == 0) {
                    global.utils.notifySuccess(this.selezionati.length + " bollettini contrassegnati come Inviati.");
                    this.selezionati = [];
                    this.caricaBollettini();
                }
            });
        },
        apriModalePagamento: function (bollettino) {
            this.bollettinoInAzione = bollettino;
            this.formPagamento.dataPagamento = new Date().toISOString().substring(0, 10);
            this.formPagamento.modalita = "Bonifico";
            this.formPagamento.note = "";
            global.utils.openModal('popUpPagamento');
        },
        salvaPagamento: function () {
            if (!this.bollettinoInAzione) return;
            global.utils.post('/emmet/bollettino/stato', {
                ID_BOLLETTINO: this.bollettinoInAzione.ID_BOLLETTINO,
                STATO: 'Pagato',
                DATA_PAGAMENTO: this.formPagamento.dataPagamento,
                MODALITA_PAGAMENTO: this.formPagamento.modalita,
                NOTE_PAGAMENTO: this.formPagamento.note
            }, (response) => {
                global.utils.closeModal('popUpPagamento');
                if (response && response.esito == 0) {
                    global.utils.notifySuccess("Pagamento del bollettino " + this.bollettinoInAzione.CODICE_BOLLETTINO + " registrato con successo!");
                    this.caricaBollettini();
                } else {
                    global.utils.notifyError(response.messaggio || "Errore nella registrazione del pagamento.");
                }
            });
        },
        riportaGenerato: function (bollettino) {
            if (!confirm("Sei sicuro di voler annullare l'incasso e riportare il bollettino " + bollettino.CODICE_BOLLETTINO + " allo stato Generato?")) {
                return;
            }
            global.utils.post('/emmet/bollettino/stato', {
                ID_BOLLETTINO: bollettino.ID_BOLLETTINO,
                STATO: 'Generato'
            }, (response) => {
                if (response && response.esito == 0) {
                    global.utils.notifySuccess("Bollettino riportato a Generato.");
                    this.caricaBollettini();
                }
            });
        }
    },
    created: function () {
        this.caricaAnni();
    }
};
</script>

<style scoped>
.text-purple {
    color: #6f42c1 !important;
}
.badge-warning {
    background-color: #ffeaa7;
    color: #d63031;
}
.btn-azione {
    width: 30px !important;
    height: 30px !important;
    padding: 0 !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    border-radius: 4px !important;
    font-size: 13px !important;
    margin: 0 2px !important;
    line-height: 1 !important;
    border: none !important;
}
.btn-azione i {
    color: #ffffff !important;
    font-size: 13px !important;
    line-height: 1 !important;
}
.btn-azione.btn-warning i {
    color: #212529 !important;
}
</style>
